import React from "react";
import FacebookIcon from "../../../../assets/images/facebookIcon.png";
import InstagramIcon from "../../../../assets/images/instagramIcon.png";
import TwitterIcon from "../../../../assets/images/twitterIcon.png";
import {
  LeftContainer,
  MainContainer,
  MiddleContainer,
  RightContainer,
  Wrapper,
  HeadingContainer,
  Heading,
  Text,
  Description,
  NumberContainer,
  LinkContainer,
  Icon,
  Heading2,
  SubHeading,
  MiddleBottomContainer,
  Line,
  HorizontalLine,
  BottomContainer,
  LastContainer,
  InnerContainer,
  InnerContainer2,
  InnerRightContainer,
  InnerLeftContainer,
  InnerContainer3,
} from "./styled.components";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <Wrapper>
      <MainContainer>
        <InnerContainer className="ooo">
          <LeftContainer>
            <HeadingContainer>
              <Heading>3H</Heading>
              <Heading>&</Heading>
              <Heading>Sons</Heading>
            </HeadingContainer>
            <Description>
              Plaza 34 Road E Block C commercial 1 (NS-1) <br></br> Naval Anchorage Islamabad Pakistan<br></br> 46000
            </Description>
            <NumberContainer>{`(+92)`} 3455088035</NumberContainer>
            <NumberContainer>{`(+92)`} 3025260606</NumberContainer>

          </LeftContainer>
          <Line />
          <MiddleContainer>
            <Heading>SiteMap</Heading>

            <InnerContainer3>
              <InnerLeftContainer>
                <SubHeading>
                  <a href="/">Home</a>
                </SubHeading>
                <SubHeading>
                  <a href="/aboutUs">About Us</a>
                </SubHeading>
                <SubHeading>
                  <a href="/gallery">Gallery</a>
                </SubHeading>
                <SubHeading>
                  <a href="/machineryEquipments">Machinery</a>
                </SubHeading>
                <SubHeading>
                  <a href="/3handgroup">3h & Group</a>
                </SubHeading>
                <SubHeading>
                  <a href="/ContactUs">Contact us</a>
                </SubHeading>
              </InnerLeftContainer>
              <InnerRightContainer>
                <SubHeading>
                  <a href="/projects">Projects</a>
                </SubHeading>
                <SubHeading>
                  <a href="/eventsandSeminars">Events and Seminars</a>
                </SubHeading>
                <SubHeading>
                  <a href="/roadsandAsphalts">Roads And Asphalts</a>
                </SubHeading>
                <SubHeading>
                  <a href="/banksandInsurances">Bank And Insurances</a>
                </SubHeading>
                <SubHeading>
                  <a href="/certificates">Certificates</a>
                </SubHeading>
              </InnerRightContainer>
            </InnerContainer3>
          </MiddleContainer>
          <Line />
          <RightContainer>
            <Heading>Find US Here</Heading>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3324.362496990397!2d73.1935685!3d33.5699362!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfef003440b98d%3A0x21903f5133581bbc!2s3H%20%26%20Sons!5e0!3m2!1sen!2s!4v1777022727168!5m2!1sen!2s"
              width="300"
              height="300"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>

            {/* <Heading2>Social</Heading2>
            <InnerContainer2>
              <Icon src={FacebookIcon} />
              <SubHeading>Facebook</SubHeading>
            </InnerContainer2>
            <InnerContainer2>
              <Icon src={TwitterIcon} />
              <SubHeading>Twitter</SubHeading>
            </InnerContainer2>
            <InnerContainer2>
              <Icon src={InstagramIcon} />
              <SubHeading>Instagram</SubHeading>
            </InnerContainer2> */}
          </RightContainer>
        </InnerContainer>
        <BottomContainer>
          <LastContainer>2026 HHHandSons / All rights reserved</LastContainer>
        </BottomContainer>
      </MainContainer>
    </Wrapper>
  );
};

export default Footer;
